module.exports = __webpack_public_path__ + "static/media/vs-code.d6de1fe3.png";